<div class="dashboard-filter-panel">
  <form (ngSubmit)="applyFilters()">
    <section class="dashboard-filter-section dashboard-filter-section-general">
      <button
        type="button"
        class="dashboard-filter-section-header"
        (click)="toggleGroup(filterGroups[0])"
        >
        <span class="dashboard-filter-section-icon">
          <i class="fas fa-sliders-h"></i>
        </span>
        <span>General Filters</span>
        <i
          class="far fa-angle-up dashboard-filter-section-toggle"
          [ngClass]="{ collapsed: $safeNavigationMigration(filterGroups[0]?.collapsed) }"
        ></i>
      </button>

      @if (!filterGroups[0]?.collapsed) {
        <div class="dashboard-filter-body">
          @for (control of filterGroups[0]?.controls; track control) {
            <ng-container
              *ngTemplateOutlet="filterControl; context: { control: control }"
            ></ng-container>
          }
        </div>
      }
    </section>

    @for (group of filterGroups.slice(1); track group) {
      <section
        class="dashboard-filter-section"
        [ngClass]="'dashboard-filter-section-' + group.modifier"
        >
        <button
          type="button"
          class="dashboard-filter-section-header"
          (click)="toggleGroup(group)"
          >
          <span class="dashboard-filter-section-icon">
            <i [class]="group.icon"></i>
          </span>
          <span>{{ group.title }}</span>
          <i
            class="far fa-angle-up dashboard-filter-section-toggle"
            [ngClass]="{ collapsed: group.collapsed }"
          ></i>
        </button>
        @if (!group.collapsed) {
          <div class="dashboard-filter-body">
            @if (group.modifier === 'om') {
              <div class="dashboard-filter-control">
                <label for="fDate">Date Range</label>
                <div class="dashboard-date-range">
                  <div class="input-wrapper">
                    <input
                      class="datepicker-dashboard pr-5"
                      name="fDate"
                      [(ngModel)]="app.filterDashboard.createTimeFilters.startDate"
                      ngbDatepicker
                      #fDate="ngbDatepicker"
                      (click)="fDate.toggle()"
                      />
                    <i class="fa fa-calendar calendar-icon" (click)="fDate.toggle()"></i>
                  </div>
                  <span class="dashboard-date-separator">-</span>
                  <div class="input-wrapper">
                    <input
                      class="datepicker-dashboard pr-5"
                      name="tDate"
                      [(ngModel)]="app.filterDashboard.createTimeFilters.endDate"
                      ngbDatepicker
                      #tDate="ngbDatepicker"
                      (click)="tDate.toggle()"
                      />
                    <i class="fa fa-calendar calendar-icon" (click)="tDate.toggle()"></i>
                  </div>
                </div>
              </div>
            }
            @for (control of group.controls; track control) {
              <ng-container
                *ngTemplateOutlet="filterControl; context: { control: control }"
              ></ng-container>
            }
          </div>
        }
      </section>
    }

    <div class="dashboard-filter-actions">
      <button
        type="submit"
        class="btn btn-default-red dashboard-filter-button"
        [disabled]="app.filterDashboard.isFilterDisabled()"
        >
        <i class="fas fa-filter"></i>
        Apply Filters
      </button>
      <button
        type="button"
        class="btn btn-reset dashboard-reset-button"
        [disabled]="!app.filterDashboard.enableReset"
        (click)="app.filterDashboard.resetFilter(true)"
        >
        <i class="fas fa-redo-alt"></i>
        Reset All Filters
      </button>
    </div>
  </form>
</div>

<ng-template #filterControl let-control="control">
  <div class="dashboard-filter-control">
    <label [for]="control.key">{{ control.label }}</label>
    @if (control.type === 'text') {
      <input
        [id]="control.key"
        [name]="control.key"
        class="dashboard-select"
        type="text"
        [placeholder]="control.placeholder"
        [(ngModel)]="app.filterDashboard.selectedOptionFilters[control.key]"
        />
    }
    @if (control.type === 'select') {
      <select
        [id]="control.key"
        [name]="control.key"
        class="dashboard-select"
        [(ngModel)]="app.filterDashboard.selectedOptionFilters[control.key]"
        >
        <option value="">{{ control.placeholder }}</option>
        @for (option of control.options; track option) {
          <option [value]="option.value">
            {{ option.text }}
          </option>
        }
      </select>
    }
  </div>
</ng-template>
